import type { TaskListRequestParams, TaskListResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { errorToastMeta } from 'common/services/queryClient'
import { type UseQueryOptions, useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

export const GET_TASKS = `/api/list/tasks`

const useTasks = (
  props: TaskListRequestParams,
  options: Omit<UseQueryOptions<any, any, any, any>, 'queryKey' | 'queryFn'>
) => {
  const queryParams = getQueryParams({ ...props, shouldPopulate: true })
  const { isLoading, data, refetch } = useQuery<GetTasksQueryResponse>(
    `tasks-${queryParams}`,
    () =>
      getJSON({
        url: queryParams ? `${GET_TASKS}?${queryParams}` : GET_TASKS
      }),
    // Merged rather than defaulted so a caller passing its own `meta` can't
    // silently opt back out of the error toast.
    { ...options, meta: { ...options?.meta, ...errorToastMeta } }
  )

  return {
    isLoading,
    tasks: data?.result,
    refetch
  }
}

export type GetTasksQueryResponse = {
  result?: TaskListResponse
}

export default useTasks
